class SearchBlock {
    constructor(el) {
        this.el = el;
        this.input = el.querySelector("input");
        this.results = el.querySelector('[data-results]');
        this.searchResultsBtn = el.querySelector("[data-search-results-page]");
        this.queryStringElement = el.querySelector("[data-query-string]");
        this.dropdownElement = el.querySelector("[data-dropdown]");
        this.reset = el.querySelector("[data-reset]");
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.reset.addEventListener("click", () => this.resetInput());
        this.input.addEventListener('keyup', e=>{
            if(e.key === "Enter"){
                this.dropdownElement.querySelectorAll("a")[0].click();
            }
        })
        this.input.addEventListener('keyup', this.debounce(() => {
            let value = this.input.value;
            this.reset.classList.toggle("hidden", value.length < 1)
            if (value.length > 2) {
                fetch(`/umbraco/surface/SearchSurface/Search?searchTerm=${value}`).then(response => response.text()).then(data => {
                    this.searchResultsBtn.href = this.searchResultsBtn.dataset.searchResultsPage + value
                    this.results.innerHTML = data;
                });
                this.queryStringElement.innerHTML = value;
                this.openDropDown();
            }
            if(value.length === 0){
                this.closeDropDown();
            }
        }, 100));
    }

    openDropDown() {
        this.el.querySelector('.dropdown').classList.add('dropdown--active');
        document.addEventListener('click', this.handleOutsideClick);
        document.addEventListener('keydown', this.handleKeydown);
    }

    closeDropDown() {
        this.el.querySelector('.dropdown').classList.remove('dropdown--active');
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleKeydown);
    }

    resetInput() {
        this.input.value = "";
        this.reset.classList.add("hidden");
        this.input.focus();
        this.closeDropDown();
    }

    handleOutsideClick(event) {
        if (!this.el.contains(event.target)) {
            this.closeDropDown();
        }
    }

    handleKeydown(event) {
        // Close dropdown on Tab key press when the focus is on the last focusable element inside the dropdown
        if (event.key === "Tab") {
            const focusableElements = this.el.querySelectorAll('input, button, [href], select, textarea, [tabindex]:not([tabindex="-1"])');
            const lastFocusableElement = focusableElements[focusableElements.length - 1];

            if ((document.activeElement === lastFocusableElement) &&  !event.shiftKey) {
                this.closeDropDown();
            }
        }
    }

    debounce(func, wait) {
        var _this = this;

        let timeout;
        return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(_this, args), wait);
        };
    }

} // Usage example:


ControlBinders.register(`[data-search-block]`, el => new SearchBlock(el));